import { object, string, number, array } from "yup";

export const WishlistItemDetailSchema = object({
    id: number().min(0),
    product_name: string().required().label("Product Name").max(500),
    product_url: string().url().required().label("Product Url").max(2048),
    image_url: string()
        .url()
        .nullable()
        .optional()
        .transform((value) => (value === "" || value === "null" ? null : value))
        .label("Image Url")
        .max(2048),
    tags: array()
        .of(object({ name: string().required().max(50) }))
        .default([]),
});
